/** @format */

import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import notificationReducers, { notify } from '../modules/notifications/reducers';
import { auth } from '../modules/auth/reducer';
import { menuReducers } from '../modules/menu/action';
import { platformUserReducers } from '../modules/platformuser/actions';
import { filterReducer } from '../modules/filter/FilterReducers';
import { filterListReducer } from '../modules/filter/FilterListReducers';
import { platformIccidMsisdnIpPoolReducer } from '../modules/iccid/PlatformIccidMsisdnIpPoolReducer';
import { storageReducers } from '../modules/storage/StorageReducers';
import { simCardReducers } from '../modules/simcard/reducers';
import { clientsReducers } from '../modules/clients/reducers';
import { cdrReducers } from '../modules/cdr/reducers';
import { geoLocationStateReducers } from '../modules/getlocationstate/reducers';
import { indicatedRangeReducers } from '../modules/indicated-range/reducers';
import { tariffsReducers } from '../modules/tariffs/reducers';
import { paymentDeadlineCodeReducers } from '../modules/paymentDeadlineCode/reducers';
import { storeStackReducer } from '../modules/lib/StoreStackReducer';
import { numberRangeReducers } from '../modules/numberRange/reducers';
import { productReducers } from '../modules/simcard/ProductReducer';
import { featuresReducers } from '../modules/features/reducers';
import { serviceReducer } from '../modules/features/FeaturesReducers';
import { blockReducers } from '../modules/block/blockReducers';
import { fractionsReducers } from '../modules/fractions/reducers';
import { serviceCodeReducers, fractionServiceCodeReducers } from '../modules/servicecode/reducers';
import { provReducer } from '../modules/provisioning/ProvisioningConnect';
import { dateReducers } from '../modules/date/DateReducers';
import { paymentDispositionReducers } from '../modules/paymentDisposition/reducers';
import { mnoOperatorSetupReducers } from '../modules/mvnoOperatorSetup/MnoOperatorSetupReducers';
import { vatReducers } from '../modules/document/VatReducer';

const loggerMiddleware = createLogger({});

const mainReducers = {
    storeStackReducer: storeStackReducer,
    notify: notify,
    notificationReducers: notificationReducers,
    auth: auth,
    menuReducers: menuReducers,
    platformUser: platformUserReducers,
    filterReducer: filterReducer,
    filterListReducer: filterListReducer,
    platformIccidMsisdnIpPoolReducer: platformIccidMsisdnIpPoolReducer,
    storageReducers: storageReducers,
    simCardReducers: simCardReducers,
    clientsReducers: clientsReducers,
    cdrReducers: cdrReducers,
    geoLocationStateReducers: geoLocationStateReducers,
    indicatedRangeReducers: indicatedRangeReducers,
    dateReducers: dateReducers,
    tariffsReducers: tariffsReducers,
    paymentDispositionReducers: paymentDispositionReducers,
    paymentDeadlineCodeReducers: paymentDeadlineCodeReducers,
    productReducers: productReducers,
    numberRangeReducers: numberRangeReducers,
    featuresReducers: featuresReducers,
    serviceReducer: serviceReducer,
    blockReducers: blockReducers,
    serviceCodeReducers: serviceCodeReducers,
    fractionServiceCodeReducers: fractionServiceCodeReducers,
    fractionsReducers: fractionsReducers,
    provReducer: provReducer,
    mnoOperatorSetupReducers: mnoOperatorSetupReducers,
    vatReducer: vatReducers,
};

function configureStore(initialState) {
    const store = createStore(createReducer(), initialState);
    store.asyncReducers = {};
    store.injectReducer = (key, asyncReducer, clean = false) => {
        if (clean) {
            store.asyncReducers = {};
        }
        store.asyncReducers[key] = asyncReducer;
        store.replaceReducer(createReducer(store.asyncReducers));
    };
    return store;
}

function createReducer(asyncReducers) {
    return combineReducers({
        ...mainReducers,
        ...asyncReducers,
    });
}

const composeEnhancers = process.env.REACT_APP_CHROME_DEBUG === 'true' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;
export const store = configureStore(composeEnhancers(applyMiddleware(thunkMiddleware, loggerMiddleware)));
